/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const CHECKOUT_OFFER_SESSION_KEY = "checkout_offer";

export const ANALYTICS_EVENTS = {
  LOGIN: "login",
  SIGN_UP: "sign_up",
  PAGE_VIEW: "page_view",
  SCREEN_VIEW: "screen_view",
  BEGIN_CHECKOUT: "begin_checkout",
  PURCHASE: "purchase",
  ADD_TO_WISHLIST: "add_to_wishlist",
  REMOVE_FROM_WISHLIST: "remove_from_wishlist",
  VIDEO_PLAYED: "video_played",
  VIDEO_DROPPED: "video_dropped",
  SIGN_UP_SUBMIT: "sign_up_submit",
  SIGN_UP_EMAIL_SENT: "sign_up_email_sent",
  FORGOT_PASSWORD: "forgot_password",
  GEOBLOCK_SHOWN: "geoblock_shown",
  VOUCHER_REDEEMED: "voucher_redeemed",
  PAYMENT_CANCELLED: "payment_cancelled",
  PAYMENT_PROCESSING: "payment_processing",
} as const;

export const ANALYTICS_GA_CATEGORIES = {
  PURCHASE: "purchase",
  VIDEO_PLAYER: "video_player",
  AUTH: "auth",
  ENGAGEMENT: "engagement",
} as const;
